module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p +=
((__t = ( html )) == null ? '' : __t) +
'\n<footer>\n    <button class="btn btn-secondary btn-large js-back">Go Back</button>\n    <button class="btn btn-primary btn-large js-next">Next</button>\n</footer>\n';

}
return __p
}